import { AccountingEntriesOverrideFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';

export const traOverrideTransformationFieldsConfiguration : AccountingEntriesOverrideFieldsConfiguration = {
    paymentProcessorConfiguration: {
        entryDescription: {},
        client: {
            account: {
                defaultValue: '411'
            }
        },
        supplier: {
            account: {
                defaultValue: '401'
            }
        }
    },

    buyInvoiceProcessorConfiguration: {
        entryDescription: {},
        thirdPartyAccount: {
            account: {
                defaultValue: '401'
            }
        }
    },

    sellInvoiceProcessorConfiguration: {
        entryDescription: {},
        thirdPartyAccount: {
            account: {
                defaultValue: '411'
            }
        }
    },

    bankProcessorConfiguration: {
        entryDescription: {},
        client: {
            account: {
                defaultValue: '411'
            }
        },
        supplier: {
            account: {
                defaultValue: '401'
            }
        }
    },

    analyticProcessorConfiguration: {
        disable: true
    }
}